import requests from "./httpService";

const RegistrationTypeServices = {

  addRegistrationType: async (body) => {
    return requests.post("/registration-type/add", body);
  },
  getAllRegistrationType: async (body) => {
    return requests.get("/registration-type/", body);
  },
  getRegistrationTypeById: async (id, body) => {
    return requests.get(`/registration-type/${id}`, body);
  },

  updateRegistrationType: async (id, body) => {
    return requests.put(`/registration-type/update/${id}`, body);
  },

  deleteRegistrationType: async (id) => {
    return requests.delete(`/registration-type/delete/${id}`);
  },
 
};

export default RegistrationTypeServices;
